import { render, staticRenderFns } from "./Editor2.vue?vue&type=template&id=a6775156"
import script from "./Editor2.vue?vue&type=script&lang=js"
export * from "./Editor2.vue?vue&type=script&lang=js"
import style0 from "./Editor2.vue?vue&type=style&index=0&id=a6775156&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports